<template>
  <div class="min-app">
    <p>
      link ->
      <input class="width200" v-model="linkUrl" type="text">
      <button @click="openLink">open</button>
    </p>

    <p>
      telegramLink ->
      <input class="width200" v-model="telegramLinkUrl" type="text">
      <button @click="openTelegramLink">open</button>
    </p>

    <p>
      msg: <input class="width100" v-model="msg" type="text">
      to chatId: <input class="width80" v-model="chatId" type="text">
      <button @click="httpSendMsg">send</button>
    </p>

    <p>
      http -> get ->
      api:<input class="width50" v-model="getApiMethod" type="text">
      <button @click="getReq">click</button>
    </p>

    <div class="p" v-if="getResData">
      <div>get res:</div>
      <div>{{ getResData }}</div>
    </div>

    <p>
      <button @click="testHandler">test click</button>
    </p>

  </div>
</template>

<script>
import axios from 'axios'
const Token = '7434681343:AAEMIo_Sb5CHK2Me5egEC-GimENPlY8S6NU'
// const Bot = '@GTimorBot'
const ChatId = 6552676474

export default {
  data() {
    return {
      meData: {},
      chatId: null,
      msg: 'hello world!',
      linkUrl: 'https://www.baidu.com',
      telegramLinkUrl: 'https://t.me/GTimorBot',
      getApiMethod: 'getMe',
      getResData: null,
      postApiMethod: '',
      postResData: null,
    }
  },
  mounted() {
    this.httpGetUpdates()
  },
  methods: {
    httpGetUpdates() {
      axios.get(`https://api.telegram.org/bot${Token}/getUpdates`).then(res => {
        let resData = res.data
        console.log(resData)
        if (resData.ok) {
          this.chatId = resData.result[0].message.chat.id
        }
      }).catch(err => console.log(err))
    },

    openLink() {
      if (!this.linkUrl) return

      window.Telegram.WebApp.openLink(this.linkUrl)
    },

    openTelegramLink() {
      if (!this.telegramLinkUrl) return

      window.Telegram.WebApp.openTelegramLink(this.telegramLinkUrl)
    },

    httpSendMsg() {
      if (!this.msg || !this.chatId) return

      // axios.get(`https://api.telegram.org/bot${Token}/sendMessage?chat_id=${ChatId}&text=HelloTimor`)
      let params = {
        chat_id: this.chatId || ChatId,
        text: this.msg
      }
      axios.post(`https://api.telegram.org/bot${Token}/sendMessage`,params).then(res => {
        let resData = res.data
        console.log(resData)
        this.$toast('Sent successfully')
      }).catch(err => console.log(err))
    },

    getReq() {
      axios.get(`https://api.telegram.org/bot${Token}/${this.getApiMethod}`).then(res => {
        let resData = res.data
        console.log(resData)
        this.getResData = resData
      }).catch(err => console.log(err))
    },

    testHandler() {
      console.log(window.Telegram.WebApp)
    }
  }
}
</script>

<style lang="less" scoped>
.min-app {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 20px;
  >p, .p {
    padding: 10px 0;
  }
  .width80 {
    width: 80px;
  }
  .width100 {
    width: 100px;
  }
  .width200 {
    width: 200px;
  }
}
</style>


// WEBPACK FOOTER //
// MinApp.vue?3c2881e9